import React, { useCallback } from "react";
import { idExtractor, useMakeListAndDetail, useMakeListBuilder } from "../core/useMakeLayout";
import { useUserSessions } from "@seabrookstudios/pitch2table";
import { NoItemsFound } from "../publisher/NoItemsFound";
import Stack from "@mui/material/Stack";
import AccessTime from "@mui/icons-material/AccessTime";
import { AddSessionDialog } from "../sessions/AddSessionDialog";
import { SessionListItemNoConvention } from "../sessions/SessionListItem";
import { SessionFromRoute } from "../sessions/SessionFromRoute";

const NoSessions = () => (
  <NoItemsFound>
    <AccessTime sx={{ fontSize: 64, color: "text.secondary", mb: 2 }} />
    <p>No meetings scheduled.</p>
  </NoItemsFound>
);

export const SessionListAndDetail = () => {
  const Action = useCallback(
    () => (
      <Stack direction="row">
        <AddSessionDialog />
      </Stack>
    ),
    []
  );

  const useMakeList = useMakeListBuilder(
    ({ item }) => <SessionListItemNoConvention session={item} />,
    idExtractor,
    "Meetings",
    NoSessions,
    Action
  );

  const useWrappedQuery = () => useUserSessions();

  const ListAndDetail = useMakeListAndDetail(useWrappedQuery, [], "sessions", useMakeList, SessionFromRoute);

  return <ListAndDetail />;
};
